import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { api } from "/src/api/client";
import StatCard from "./StatCard";

const WIDGET_META = [
  { id: 1, label: "Awaiting Review", key: "awaiting_review", danger: false },
  { id: 2, label: "In Progress",     key: "in_progress",     danger: false },
  { id: 3, label: "Ready to Execute",       key: "scripts_generated",       danger: false },
  { id: 4, label: "Failed",          key: "failed",          danger: true  },
];

const DeploymentSummaryWidgets = ({ engagementId }) => {
  const [values, setValues] = useState({});

  const fetchStats = useCallback(async () => {
    try {
      const { data } = await api.get("/golive/deployment_requests/stats", {
        params: { engagement_id: engagementId },
      });
      setValues(data || {});
    } catch (err) {
      console.error("Error fetching run stats", err);
    }
  }, [engagementId]);

  useEffect(() => {
    fetchStats(); // eslint-disable-line react-hooks/set-state-in-effect
  }, [fetchStats]);

  return (
    <div className="flex gap-4 flex-wrap">
      {WIDGET_META.map((m) => (
        <StatCard
          key={m.id}
          label={m.label}
          count={values?.[m.key] ?? 0}
          danger={m.danger}
        />
      ))}
    </div>
  );
};

DeploymentSummaryWidgets.propTypes = {
  engagementId: PropTypes.string.isRequired,
};

export default DeploymentSummaryWidgets;
